import React, {useContext, useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import * as Dati from "src/Dati";
import * as Glob from "src/Globale";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import ChiamaWeb, {CChiamaWebParametri} from "src/ChiamaWeb";
import {BottoneAPI, Trad} from "src/components/";
import {CData} from "src/Data";
import {_ButtonAPI, _Derogation, _Button} from "../../components";
import useDerogation from "../../hooks/Derogation";
import {IRouteParam} from "../../pages/PolicyNeutral";
import {AlertDialogContext} from "../../providers/AlertDialogProvider";
import useToggle from "../../../hooks/Toggle";
import {_RenewalActionDialog} from "../RenewalPoliciesList/ActionDialog";
import {_ActionDialog} from "../common/ActionDialog";
import {_PolicyNeutralFormContent} from "./PolicyNeutralFormContent";

const Tax = 0.125;

export const _PolicyNeutralForm: React.FC = () => {
    const history = useHistory();
    const {open, toggle} = useToggle();
    const {ID_Anag, ID_Polizza} = useParams<IRouteParam>();
    const {ShowDialog} = useContext(AlertDialogContext);
    const editingRights = Glob.AzioneAbilitata("PolizzaController", Glob.Scrittura);
    const initialData = new Dati.CRisAPIDatoTipiInfo_Polizza();
    initialData.Dato.ID_AnagContraente = Number(ID_Anag);

    const [Data, setData] = useReducerOnChange<Dati.CRisAPIDatoTipiInfo_Polizza>(initialData);
    const [BondData, setBondData] = useReducerOnChange<any>({});
    const [ProductBinder, setProductBinder] = useState("");
    const [Limits, setLimits] = useState<Dati.Dictionary<number>>({});
    const {DerogationFieldsList, OnChangeDerogation} = useDerogation();


    useEffect(() => {GetData();}, [ID_Anag, ID_Polizza]);

    useEffect(() => {
        if (ID_Polizza == '0' && Data.Dato.ID_TipoProdotto == 0) {
            GetNewPolicyData();
        }
    }, [Data.Dato.ID_TipoProdotto, ID_Polizza]);

    //useEffect(() => {GetProductBinder();}, [ID_Polizza, Data.Dato.ID_TipoProdotto, Data.Dato.DataEffetto]);

    const OnApiError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    const GetData = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/polizza/?id_Polizza=${ID_Polizza}&id_AnagContraente=${ID_Anag}&isNeutral=true`,
            OnRis: OnGetData,
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetData = (sender: ChiamaWeb, data: Dati.CRisAPIDatoTipiInfo_Polizza) => {
        if (data.Dato.CoAssicurazioneJSON) {
            setProductBinder(GetProductBinder(data.Dato.CoAssicurazioneJSON));
        }
        if (data.ID_Chiave > 0) {
            const newPolicy: any = Glob.CreaClassePolizzaFide(data.Info);
            newPolicy.ProvCompagnia = 25;
            const policyData: any = JSON.parse(data.Dato.DatiPolizza);

            for (let key in newPolicy) {
                if (policyData[key] != undefined) {
                    newPolicy[key] = policyData[key];
                }
                if (key == "ImpegnoRilascio" && newPolicy[key] == "") {
                    newPolicy[key] = true;
                }
            }
            setData({Type: "Set", Value: data});
            setBondData({Type: "Set", Value: newPolicy});
        }
    };

    const GetNewPolicyData = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/polizza/GetInfoPolizza?ID_TipoProdotto=${100}`,
            OnRis: OnGetNewPolicyData,
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetNewPolicyData = (sender: ChiamaWeb, data: Dati.CRisAPIDatoTipiInfo_Polizza) => {
        let emptyPolicy: Dati.CRisAPIDatoTipiInfo_Polizza = new Dati.CRisAPIDatoTipiInfo_Polizza();
        emptyPolicy.Info = data.Info;
        emptyPolicy.Dato = Data.Dato;

        let newPolicy: any = Glob.CreaClassePolizzaFide(data.Info);
        newPolicy.LuogoEsecuzione = "Vedasi oggetto garanzia";
        if (
            Data.Dato.ID_TipoProdotto == Glob.TipoProdotto_CauzioneProvvisoriaLavori ||
            Data.Dato.ID_TipoProdotto == Glob.TipoProdotto_CauzioneProvvisoriaForniture ||
            Data.Dato.ID_TipoProdotto == Glob.TipoProdotto_CauzioneProvvisoriaServizi
        ) {
            const duration = 180;
            const reliefDate = new CData(moment(Data.Dato.DataEffetto).toDate(), true).AddGiorni(duration).Data;

            newPolicy.Durata = duration;
            newPolicy.DataSvincolo = reliefDate;
            emptyPolicy.Dato.DataFine = reliefDate;
        }
        setData({Type: "Set", Value: emptyPolicy});
        setBondData({Type: "Set", Value: newPolicy});
    };

    const GetProductBinder = (coInsuranceJson: string): string => {
        if (coInsuranceJson && coInsuranceJson !== "[]") {
            const coInsurance: Dati.CDatoCoAssicurazione[] = JSON.parse(coInsuranceJson);
            return `${coInsurance[0].ID_Binder}-${coInsurance[0].ID_BinderCompagnia}-${coInsurance[0].ID_Anag}`;
        }

        return "";
    };

    const GetFormData = (calculate = false, draft = false): Dati.CIngrAPI<Dati.CDatiPolizza> => {
        const formData = new Dati.CIngrAPI<Dati.CDatiPolizza>();

        formData.Dato = Data.Dato;
        formData.Dato.ID_AnagContraente = Number(ID_Anag);
        formData.Dato.ID_Polizza = Number(ID_Polizza);
        formData.Dato.DatiPolizza = JSON.stringify({...BondData});
        if (!calculate) {
            if (!draft) {
                formData.Dato.ID_TipoPolizzaStato = Glob.Tipi_PS_Preventivo;
            } else {
                formData.Dato.ID_TipoPolizzaStato = Glob.Tipi_PS_PreventivoBozzaInviata;
            }
        }
        return formData;
    };

    const OnClickSave = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            ShowDialog("ERRORE", data.ErrTesto, "error");
        } else {
            if (ID_Polizza == "0") {
                history.push(`/anagrafica/${ID_Anag}/PolizzaNeutra/${data.ID_Chiave}`);
            }
            const savedData = {...Data};

            savedData.Dato.ID_Polizza = data.ID_Chiave;
            savedData.Dato.Polizza = data.MessaggioTesto;
            savedData.Dato.ContraenteATI = data.MessaggioDati[0];
            savedData.Dato.ID_TipoFileRichiesto = data.MessaggioDati[1];

            ShowDialog("POLIZZA", Trad.TradParam("Polizza salvata correttamente con ID: {1-S}", [data.ID_Chiave]), "success");
            setData({Type: "Set", Value: savedData});
            history.push(`/anagrafica/${ID_Anag}/PolizzaNeutra/${data.ID_Chiave}`);
        }
    };

    const OnSendCancel = (): any =>
    {
        var cancelData = new Dati.CIngrAPI<Dati.CDatiPolizzaAnnullamento>();
        cancelData.Dato.ID_Polizza = Data.Dato.ID_Polizza;

        cancelData.Dato.TipologiaAnnullamento = 1;
        return cancelData;
    }
    
    const OnCancel = (): void => {
        const Param: CChiamaWebParametri = {
            Metodo: "POST",
            URL: `/api/polizza/annullapolizza`,
            OnInvio: OnSendCancel,
            OnRis: (sender: ChiamaWeb, dati: Dati.CRisAPI) => {
                if (dati.Errore) {
                    ShowDialog("ERRORE", dati.ErrTesto, "error");
                } else {
                    toggle();
                    GetData();
                    ShowDialog("POLIZZA", Trad.TradParam("Polizza annulata correttamente con ID: {1-S}", [dati.ID_Chiave]), "success");
                    history.push(`/anagrafica/${ID_Anag}/PolizzaNeutra/${ID_Polizza}`);
                }
            },
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnClickRelease = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            ShowDialog("ERRORE", data.ErrTesto, "error");
        } else {
            if (ID_Polizza == "0") {
                history.push(`/anagrafica/${ID_Anag}/PolizzaNeutra/${data.ID_Chiave}`);
            }
            const savedData = {...Data};

            savedData.Dato.ID_Polizza = data.ID_Chiave;
            savedData.Dato.Polizza = data.MessaggioTesto;
            savedData.Dato.ContraenteATI = data.MessaggioDati[0];
            savedData.Dato.ID_TipoFileRichiesto = data.MessaggioDati[1];

            ShowDialog("POLIZZA", Trad.TradParam("Polizza emessa correttamente con ID: {1-S}", [data.ID_Chiave]), "success");
            setData({Type: "Set", Value: savedData});
            history.push(`/anagrafica/${ID_Anag}/PolizzaNeutra/${data.ID_Chiave}`);
        }
    };
    
    const OnClickChangeState = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            ShowDialog("ERRORE", data.ErrTesto, "error");
        } else {
            if (ID_Polizza == "0") {
                history.push(`/anagrafica/${ID_Anag}/PolizzaNeutra/${data.ID_Chiave}`);
            }
            ShowDialog("POLIZZA", "Polizza salvata correttamente", "success");
            GetData();
        }
    };

    const OnBlurAmount = () => {
        const newPolicy = {...BondData};
        const hasExtensions = Object.keys(Data.Info).some(item => Data.Info[item].Campo == "ProrogheAccessori" || Data.Info[item].Campo == "ProrogheDa");
        if (BondData.PremioNetto < Limits["PremioNettoMIN"] || BondData.PremioNetto > Limits["PremioNettoMAX"]) {
            const premioNetto = BondData.PremioNetto < Limits["PremioNettoMIN"] ? Limits["PremioNettoMIN"] : Limits["PremioNettoMAX"];
            const warningMessage = BondData.PremioNetto < Limits["PremioNettoMIN"] ? "PremioImpostatoInferioreAlPremioMinimo" : "PremioImpostatoSuperioreAlLimite";

            newPolicy.PremioNetto = premioNetto;
            newPolicy.Imponibile = premioNetto + (newPolicy.Accessori * premioNetto) / 100 + newPolicy.DirittiEmissione;
            newPolicy.Imposte = newPolicy.Imponibile * Tax;
            newPolicy.PremioFinito = newPolicy.Imponibile + newPolicy.Imposte;

            setBondData({Type: "Set", Value: newPolicy});
            ShowDialog("WARNING", Trad.Trad(warningMessage), "warning");
        } else {
            let ImponibileCalcolato: number = BondData.PremioNetto + (BondData.PremioNetto * BondData.Accessori) / 100 + BondData.DirittiEmissione;

            if (Math.abs(BondData.Imponibile - ImponibileCalcolato) >= 0.01) {
                ShowDialog(
                    "WARNING",
                    Trad.TradParam("ImponibileCalcolato{1-I}ImponibileInseritoDifferenti{2-I}Differenza{3-I}", [ImponibileCalcolato, BondData.Imponibile, BondData.Imponibile - ImponibileCalcolato]),
                    "warning"
                );
            }
        }
    };

    const OnChangeAmount = (e: string, val: string) => {
        const newPolicy = {...BondData};
        const value = Number(val);

        switch (e) {
            case "PremioNetto":
                newPolicy.Imponibile = value + (newPolicy.Accessori * value) / 100 + newPolicy.DirittiEmissione;
                newPolicy.Imposte = newPolicy.Imponibile * Tax;
                newPolicy.PremioFinito = newPolicy.Imponibile + newPolicy.Imposte;
                break;
            case "DatoFidePolizza.Accessori":
                newPolicy.Imponibile = newPolicy.PremioNetto + (value * newPolicy.PremioNetto) / 100 + newPolicy.DirittiEmissione;
                newPolicy.Imposte = newPolicy.Imponibile * Tax;
                newPolicy.PremioFinito = newPolicy.Imponibile + newPolicy.Imposte;
                break;
            case "DatoFidePolizza.DirittiEmissione":
                newPolicy.Imponibile = newPolicy.PremioNetto + (newPolicy.Accessori * newPolicy.PremioNetto) / 100 + value;
                newPolicy.Imposte = newPolicy.Imponibile * Tax;
                newPolicy.PremioFinito = newPolicy.Imponibile + newPolicy.Imposte;
                break;
            case "DatoFidePolizza.Imponibile":
                newPolicy.Imposte = value * Tax;
                newPolicy.PremioFinito = value + newPolicy.Imposte;
                break;
            case "DatoFidePolizza.Imposte":
                newPolicy.Imponibile = value / Tax;
                newPolicy.PremioFinito = newPolicy.Imponibile + value;
                break;
            case "DatoFidePolizza.PremioFinito":
                newPolicy.Imposte = value / (1 / Tax + 1);
                newPolicy.Imponibile = value / (1 + Tax);
                newPolicy.PremioNetto = (newPolicy.Imponibile - newPolicy.DirittiEmissione) / ((100 + newPolicy.Accessori) / 100);
                break;
        }
        newPolicy[e] = val;
        setBondData({Type: "Set", Value: newPolicy});
    };

    const ParametrsChangeState: { [Param: string]: any } = [];
    ParametrsChangeState["id_Polizza"] = ID_Polizza;


    const isFormValid = true;
    const showActionButtons = Data.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Preventivo
        || Glob.Tipi_PS_PreventivoBozzaInviata
        || Data.Dato.ID_TipoPolizzaStato == "";

    const showChangeStateButtons = Data.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Emessa;

    return (
        <Card>
            <_ActionDialog
                Open={open}
                Title={"Confirm"}
                Message={`Annulla la polizza ${Data.Dato.Polizza}?`}
                OnCancel={toggle}
                OnConfirm={OnCancel}
                OnClose={toggle}
            />
            <CardContent>
                <form noValidate autoComplete="off">
                    <_PolicyNeutralFormContent
                        Data={Data}
                        BondData={BondData}
                        Limits={Limits}
                        ProductBinder={ProductBinder}
                        RiduzioneSommaGarantita={undefined}
                        OnBlurAmount={OnBlurAmount}
                        OnChangeAmount={OnChangeAmount}
                        OnChangeDerogation={OnChangeDerogation}
                        OnChangeBondData={(e, val) => setBondData({Type: "OnChangeFromValue", Name: e, Value: val})}
                        OnChange={(e, val) => setData({
                            Type: "OnChangeFromHybrid",
                            NameEvent: val != null && val != undefined ? e : Object.assign({}, e),
                            Value: val
                        })}
                    />
                </form>
            </CardContent>

            <CardActions disableSpacing>
                <Grid item container xs={6} spacing={3} justify={"flex-start"}>
                    {editingRights && showActionButtons && Data.Dato.ID_TipoPolizzaStato == Glob.Tipi_PS_Emessa && (
                        <Grid item>
                            <_Button Default
                                     Attivo={isFormValid}
                                     Testo={Trad.Trad("Annulla")}
                                     OnClick={() => toggle()}
                            />
                        </Grid>
                    )}
                </Grid>
                <Grid item container xs={6} spacing={3} justify={"flex-end"} >
                    {editingRights && showActionButtons && (
                        <>
                            <Grid item>
                                <_ButtonAPI Attivo={isFormValid} Testo={Trad.Trad("Salva")}
                                            URL="/api/polizza/salvapolizza?emission=false" 
                                            OnInvio={GetFormData} 
                                            OnClick={OnClickSave}
                                            OnErrore={OnApiError}/>
                            </Grid>
                            <Grid item>
                                <_ButtonAPI Default Attivo={isFormValid} Testo={Trad.Trad("Emetti")}
                                            URL="/api/polizza/salvapolizza?emission=true" 
                                            OnInvio={GetFormData} 
                                            OnClick={OnClickRelease}
                                            OnErrore={OnApiError}/>
                            </Grid>

                        </>
                    )}
                    {Number(ID_Polizza) > 0 && Object.keys(DerogationFieldsList).length > 0 &&
                        <_Derogation Data={DerogationFieldsList} Id={Number(ID_Polizza)} Type={Glob.Tipi_DT_Polizza}/>}
                </Grid>
            </CardActions>
        </Card>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/PolicyNeutral/PolicyNeutralForm.tsx